function cache(key: string, def: any = {}) {
  return (
    (window.localStorage.getItem(key) &&
      JSON.parse(window.localStorage.getItem(key) as any)) ||
    def
  );
}

const impersonation = JSON.parse(window.sessionStorage.getItem('impersonation'))

export default {
  isAuthenticated: !!window.localStorage.getItem('auth-token'),
  isAuthorized: true,
  isProfileLoaded: false,
  user: null,
  acl: null,
  member: null,
  authToken: window.localStorage.getItem('auth-token'),
  impersonation: {
    id:impersonation?.id,
    email:impersonation?.email,
  },
}